import axios, { AxiosResponse } from "axios";
import {IAdminFilterParams, IAdminListResult} from "./service-find-admin.type";

/**
 * Список администраторов
 */
export const getAdminList = (data: IAdminFilterParams): Promise<AxiosResponse<IAdminListResult>> => {
    return axios.post(`/services/isnaportal/open-api/admin/filter`, data);
};

/**
 * Получение excel файла со списком администраторов
 */
export const getAdminListFile = (data: IAdminFilterParams): Promise<AxiosResponse<Blob>> => {
    return axios.post(`/services/isnaportal/open-api/admin/generate`, data, {
        responseType: "arraybuffer",
    });
};
